"use client";

import { useEffect } from "react";
import { analytics } from "@/lib/analytics/core";
import { ga4Adapter } from "@/lib/analytics/providers/ga4";
import { gtmAdapter } from "@/lib/analytics/providers/gtm";
import { clarityAdapter } from "@/lib/analytics/providers/clarity";

/**
 * Registers all analytics adapters on mount.
 * The core auto-initialises when consent is granted (or immediately
 * when the consent popup is disabled).
 *
 * To add a new provider:
 *   1. Create an adapter in lib/analytics/providers/
 *   2. Import + register it here.
 */
export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    analytics.register(ga4Adapter);
    analytics.register(gtmAdapter);
    analytics.register(clarityAdapter);
  }, []);

  return <>{children}</>;
}
